import React from 'react'
import { Nullable } from '../../common/props'
import useStyles from './SecondaryBadge.styles'
import clsx from 'clsx'

export type SecondaryBadgeProps = {
  title: string
  variant: 'DARK_GREY' | 'GOLD' | 'FF_GREY' | 'FF_CHARCOL' | 'FF_WHILD_EXOTIC' | 'FF_COBALT' | 'FF_JADE'
}

export type Props = {
  secondaryBadge: SecondaryBadgeProps
  className?: string
  isFromSimpleCard?: boolean
  isFromSearchCard?: boolean
}

const SecondaryBadge = (props: Props) => {
  const { secondaryBadge, className, isFromSimpleCard, isFromSearchCard } = props as Nullable<Props>
  const { classes } = useStyles()
  return (
    <>
      {!!secondaryBadge?.title ? (
        <div
          className={clsx(
            classes.titleContainer,
            classes[secondaryBadge.variant ?? 'DARK_GREY'],
            className ?? '',
            isFromSimpleCard ? classes.simpleCardTitle : '',
            isFromSearchCard ? classes.searchCardAlignment : ''
          )}
        >
          {secondaryBadge.title}
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export default SecondaryBadge
